import { DialogService, GridAction } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { TopicsConfigureTopicDialog } from '../configure-topic-dialog/configure-topic.dialog';
import { TopicRow } from '../topics-view.part';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService) {

	const actions: GridAction<TopicRow>[] = [{
		label: `Configure Topic`,
		iconClass: 'fa-regular fa-pencil',
		isEnabled: rows => !!rows.length,
		execute: async rows => {
			const accTopicId = rows[0]?.accTopicId;
			const needsSpecialist = rows[0]?.needsSpecialist;
			if (!needsSpecialist) {
				await dialogService.showMessage('Information', 'This topic does not require specialists, so there is no configuration needed.');
			}
			else if (accTopicId) {
				await dialogService.showCustom(TopicsConfigureTopicDialog, { data: { accTopicId } }, 500, 300);
				await areaService.reloadData();
			}
		}
	},
	{
		iconClass: 'fa-regular fa-calendar-lines',
		label: 'View Training Materials',
		isEnabled: rows => !!rows.length && rows[0]!.materialsCount > 0,
		execute: async rows => { console.log(`Action clicked!`, rows) }
	},
	];

	return actions;
}